import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBgiJDCt8gFzNG0ZYZjsCHI4GIseBVDZug",
    authDomain: "kdc-notification.firebaseapp.com",
    projectId: "kdc-notification",
    storageBucket: "kdc-notification.firebasestorage.app",
    messagingSenderId: "779069907409",
    appId: "1:779069907409:web:43cce66f02eea6be8e00f0",
    measurementId: "G-50M4SJFK8Y"
};

const app = initializeApp(firebaseConfig);
export const messaging = typeof window !== "undefined"
    ? getMessaging(app)
    : null;
